import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Lightbulb } from "lucide-react";

const StandUpNaKonferencje = () => (
  <SeoPageLayout title="Stand-up" titleAccent="na konferencję">
    <SeoSection title="Komik jako element konferencji">
      <p>Konferencje biznesowe bywają monotonne - prezentacja za prezentacją, slajd za slajdem. Przerywnik w postaci profesjonalnego stand-upu to nie tylko rozrywka, ale strategiczny element programu. Śmiech regeneruje uwagę, odświeża umysły i sprawia, że uczestnicy lepiej zapamiętują całe wydarzenie.</p>
    </SeoSection>

    <SeoSection title="Gdzie w programie konferencji umieścić stand-up?">
      <SeoStyledList items={[
        "Na otwarcie - energetyczne rozpoczęcie, które od razu buduje pozytywną atmosferę",
        "Między panelami - odświeżenie uwagi uczestników w środku dnia",
        "Po lunch break - ponowne zaangażowanie publiczności po przerwie",
        "Na zakończenie - pozytywny finał, który uczestnicy zapamiętają najdłużej",
        "Podczas gali wieczornej - rozrywka towarzysząca kolacji i networkingowi"
      ]} />
    </SeoSection>

    <SeoSection title="Tematyczny stand-up konferencyjny">
      <p>Nasi komicy potrafią przygotować materiał nawiązujący do tematu przewodniego konferencji. Jeśli konferencja dotyczy transformacji cyfrowej, innowacji, sprzedaży czy zarządzania - komik wplecie te wątki w swój występ, tworząc spójne i angażujące doświadczenie dla uczestników.</p>
      <SeoHighlightBox icon={Lightbulb}>
        Tematyczny stand-up zwiększa retencję informacji - uczestnicy lepiej zapamiętują kluczowe przesłania konferencji, gdy towarzyszył im śmiech.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Stand-up na konferencji - aspekty praktyczne">
      <p>Występ konferencyjny trwa zazwyczaj 15-30 minut. Komik korzysta z dostępnego nagłośnienia konferencyjnego i może wystąpić zarówno na dużej scenie przed setkami osób, jak i w kameralnej sali szkoleniowej. Dostosowujemy format i energię występu do wielkości grupy i charakteru wydarzenia.</p>
    </SeoSection>

    <SeoSection title="Referencje z konferencji">
      <p>Występowaliśmy na dziesiątkach konferencji branżowych w całej Polsce. Nasi komicy mają doświadczenie w występach przed publicznością liczącą od kilkudziesięciu do kilku tysięcy osób. Znamy specyfikę wydarzeń konferencyjnych i wiemy, jak dopasować energię występu do oczekiwań organizatorów.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpNaKonferencje;
